export default __webpack_public_path__ + "static/media/decline-24dp.fc797bca.svg";